import { createSelector } from '@reduxjs/toolkit';

import { getChatHeaderTitle } from '../../utils/getChatHeaderTitle';
import { selectChatHeader } from '../chatHeaderSelector';

export const selectChatUserTitle = createSelector(selectChatHeader, getChatHeaderTitle);
